import { intersection, isEmpty } from 'lodash';
export default function doesMatchMultiFilter(selectedFilters, getValues) {
  return function predicate(item) {
    // Annoying that we seem to need the cast?
    return Object.keys(selectedFilters).every(key => isEmpty(selectedFilters[key]) || intersection(selectedFilters[key], getValues(item, key)).length > 0);
  };
}